import { Component } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { AddressHint, ChildHint, HintKind, PersonHint } from './hint.model';
import { resolveOwnerId } from './hint.utils';

type Hint = AddressHint | ChildHint | PersonHint;

/** `props` understood by the `hint-fill` formly type. */
export interface HintFillProps {
  hintKind: HintKind;
  /** Applies the picked hint. Receives this button's own field config so it can locate targets. */
  hintApply: (field: FormlyFieldConfig, hint: Hint) => void;
}

/**
 * A formly wrapper around {@link import('./hint-fill-button.component').HintFillButtonComponent} so
 * the "fill from history" button can be dropped straight into a `FormlyFieldConfig[]` (used by the
 * employee-guide steps, whose sections are pure formly fields with no host component). Placement
 * supplies the apply logic via `props.hintApply`, mirroring the `tigger-button` `change` pattern.
 */
@Component({
  selector: 'tpa-hint-fill-field',
  template: `
    <tpa-hint-fill-button
      [kind]="to['hintKind']"
      [ownerId]="ownerId"
      (pick)="onPick($event)"
    ></tpa-hint-fill-button>
  `,
  styles: [':host { display: block; width: 100%; }'],
})
export class HintFillFieldType extends FieldType {
  get ownerId(): number | null {
    return resolveOwnerId(this.options?.formState);
  }

  onPick(hint: Hint): void {
    (this.props as unknown as HintFillProps)?.hintApply?.(this.field, hint);
  }
}
